import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DocumentService } from './document.service';
import { catchError } from 'rxjs/operators';
import { empty } from 'rxjs/observable/empty';
import { Observable } from 'rxjs/Observable';
import { HttpService } from '../shared/core/http.service';
import { ViewingSessionModel } from './viewingsession.model';
import { data } from 'jquery';
import { Location } from '@angular/common';
const EMPTY_OBSERVABLE: Observable<never> = empty();

@Component({
  selector: 'app-document-detail',
  template: require('./document-detail.component.html'),
  styles: [require('./document-detail.component.css')]
})
export class DocumentDetailComponent implements OnInit {
  filename: string;
  viewingSessionId: string = '';
  viewerControl: any;
  canInteract = false;
  error: Error = null;
  originalname:string;

  constructor(
    private route: ActivatedRoute,
    private documentService: DocumentService,
    private _httpService: HttpService,
    private location: Location
  ) {
    this.filename = this.route.snapshot.paramMap.get('filename')!;
    this.originalname = this.route.snapshot.paramMap.get('originalname')!;
  }

  ngOnInit(): void {
    var parent = this;

    this.documentService.createViewingSession(this.filename)
      .subscribe(
        (data: ViewingSessionModel) => {
          parent.viewingSessionId = data.viewingSessionId;
          this.viewingSessionId = data.viewingSessionId;
        },
        (error) => {
          console.error('Error:', error);
        }
      )
  }


mapViewingSession(response: Response): ViewingSessionModel {
  var data: any = response.json();
  if (data){
    let viewingSessionModel: ViewingSessionModel = new ViewingSessionModel();
    viewingSessionModel.viewingSessionId = data.viewingSessionId;
    this.viewingSessionId = viewingSessionModel.viewingSessionId;
    return viewingSessionModel;
  }
  return null;
}

  // Call this method to store a reference to the viewerControl so we can use its API.
  setViewerControl(viewerControl: any): void {
    // Store a reference to the viewerControl.
    this.viewerControl = viewerControl;
    var parent = this;

    // Update our "canInteract" variable whenever the viewer is fully ready. For
    // the full list of PCCViewer.EventType values you can subscribe to, see
    // https://help.accusoft.com/PrizmDoc/v13.13/HTML/PCCViewer.html#.EventType
    this.viewerControl.on((window as any).PCCViewer.EventType.ViewerReady, () => {
      this.canInteract = true;
      parent.viewerControl.scaleFactor = 1;
    });
  }

  // Calls the viewerControl API to navigate to the next page.
  nextPage(): void {
    this.viewerControl.changeToNextPage();
  }

  // Calls the viewerControl API to navigate to the previous page.
  previousPage(): void {
    this.viewerControl.changeToPrevPage();
  }

  return(){
    this.location.back();
  }
}




// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/docviewer/document-detail.component.ts